<template>
  <div>
    <v-list>
      <ListItem
        :title="editor.name"
        :subtitle="$t('fields.name')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'EditorDetails',
    components: { ListItem },
    props: {
      editor: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
